import { runQuery } from '../graphQl'
import * as checkListQuery from '../query/checklist'
import config from '../../config.js'
import store from '../../store'

export const getFormChecklist = async (skip, perPage, settings = false, search, sorting) => {
  const conditions = {}
  let orderBy = { created_on: 'desc' }
  if (sorting === '2') {
    orderBy = { created_on: 'asc' }
  } else if (sorting === '3') {
    orderBy = { name: 'asc' }
  } else if (sorting === '4') {
    orderBy = { name: 'desc' }
  } else orderBy = { created_on: 'desc' }
  if (settings) {
    conditions.form_type = { _in: [config.SAFETY_CHECKLIST_FORM.form_type, config.QUALITY_CHECKLIST_FORM.form_type, config.PROCESS_CHECKLIST_FORM.form_type, config.DOCUMENTATION_CHECKLIST_FORM.form_type] }
  }
  if (search?.length) {
    conditions.name = { _ilike: `%${search}%` }
  }
  if (store.getters?.collaborator) {
    const projectId = store.getters.projectIdForCollaborator
    const collaboratorId = store.getters?.collaboratorId
    conditions.template_versions = { core_forms: { tenant_id: { _eq: collaboratorId } } }
    if (!projectId) {
      conditions.template_versions.core_forms.project_id = { _is_null: true }
    } else {
      conditions.template_versions.core_forms.project_id = { _eq: store.getters.projectIdForCollaborator }
    }
  }
  return runQuery(checkListQuery.getCheckList(), { conditions, perPage, skip, orderBy }, 'tenant')
}

export const getCheckListById = (id) => {
  return runQuery(checkListQuery.getCheckListByIdQuery(), { id }, 'tenant')
}
